import { TextInput } from "@narmi/design_system";
import {
  StateSelector,
  ZipCodeTextInput,
  AutocompleteStreetAddress,
  ContextForm,
} from "cerulean";
import Address from "byzantine/src/Address";
import utils from "byzantine/src/utils";
import azulUtils from "../../utils";

interface BankingUSAddressFieldProps {
  addressType?: string;
  onUpdate?: (val: Partial<Address>) => void;
  data: any;
  errors?: any;
  title?: string;
  showTitle?: boolean;
  streetAddressLabel?: string;
  apartmentLabel?: string;
  cityLabel?: string;
  stateLabel?: string;
  zipCodeLabel?: string;
  marginTop?: string;
  marginBottom?: string;
  field?: string;
  disallowAddressPoBox?: boolean;
}

const BankingUSAddressField = ({
  addressType,
  onUpdate,
  data,
  errors = {},
  title,
  showTitle = true,
  streetAddressLabel = "Street Address",
  apartmentLabel = "Apt/Fl/Suite",
  cityLabel = "City",
  stateLabel = "State",
  zipCodeLabel = "Zip code",
  marginTop = "margin--top--l",
  marginBottom = "margin--bottom--l",
  disallowAddressPoBox,
}: BankingUSAddressFieldProps) => {
  const isAutocompleteApiAvailable = !!(window as any).google?.maps;

  return (
    <>
      {addressType && showTitle && (
        <div
          className="margin--top--xl fontWeight--bold"
          style={{ color: "var(--color-black)" }}
        >
          {title || addressType}
        </div>
      )}
      <div className={`banking-address-grid ${marginTop} ${marginBottom}`}>
        <ContextForm.Field
          required
          style={{ flex: 2, marginBottom: 0 }}
          validate={(value: string) =>
            utils.validateStreetAddress(value, !disallowAddressPoBox)
          }
        >
          {isAutocompleteApiAvailable ? (
            <AutocompleteStreetAddress
              value={data.street_address || ""}
              address_type={addressType}
              onUpdate={onUpdate}
              error={errors.street_address}
              streetAddressLabel={streetAddressLabel}
              field="street_address"
              autoComplete="address-line1"
            />
          ) : (
            <TextInput
              label={streetAddressLabel}
              value={data.street_address || ""}
              error={errors.street_address}
              field="street_address"
              autoComplete="address-line1"
            />
          )}
        </ContextForm.Field>
        <div>
          <ContextForm.Field style={{ flex: 1, marginBottom: 0 }}>
            <TextInput
              label={apartmentLabel}
              value={data.street_address_2}
              error={errors.street_address_2}
              field="street_address_2"
              autoComplete="address-line2"
            />
          </ContextForm.Field>
        </div>
      </div>
      <ContextForm.Field required>
        <TextInput
          label={cityLabel}
          value={data.city}
          error={errors.city}
          field="city"
          autoComplete="address-level2"
        />
      </ContextForm.Field>
      <div className={`banking-address-grid ${marginTop} ${marginBottom}`}>
        <ContextForm.Field required style={{ flex: 1, marginBottom: 0 }}>
          <StateSelector
            label={stateLabel}
            value={data.region_code}
            error={errors.region_code}
            field="region_code"
            autoComplete="address-level1"
          />
        </ContextForm.Field>
        <ContextForm.Field
          required
          style={{ flex: 2, marginBottom: 0 }}
          validate={(_value: string, addressData: API.Address) =>
            azulUtils.validateAddress(addressData).postal_code
          }
        >
          <ZipCodeTextInput
            label={zipCodeLabel}
            value={data.postal_code}
            field="postal_code"
            autoComplete="postal-code"
          />
        </ContextForm.Field>
      </div>
    </>
  );
};

export default BankingUSAddressField;
